module.exports = __webpack_public_path__ + "static/media/maki_avocado.87e4ebdb.webp";